module.exports = __webpack_public_path__ + "img/4-m.b2b5be57.jpg";